import type { Priority } from '@/shared/types/projectData';

export const PRIORITY_HEX_COLORS: Record<Priority, string> = {
  low: '#059669',
  medium: '#d97706',
  high: '#ea580c',
  critical: '#dc2626',
};

export const PRIORITY_ACTIVE_CLASSES: Record<Priority, string> = {
  low: 'text-green-700 bg-green-100 dark:text-green-400 dark:bg-green-500/20',
  medium: 'text-amber-700 bg-amber-100 dark:text-yellow-400 dark:bg-yellow-500/20',
  high: 'text-orange-700 bg-orange-100 dark:text-orange-400 dark:bg-orange-500/20',
  critical: 'text-red-700 bg-red-100 dark:text-red-400 dark:bg-red-500/20',
};

export const PRIORITY_LABELS: Record<Priority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  critical: 'Critical',
};

export const getPriorityHexColor = (priority?: string): string =>
  PRIORITY_HEX_COLORS[(priority as Priority) || 'medium'] || '#6b7280';
